<template>
  <div class="intro-top-div" v-if="pooqzoneInfo !== null">
    <section id="sec01" class="intro-sec01">
      <div class="intro-sec01-top">
        <h1 class="intro-pooqzone">
          <img src="@/assets/images/intro/wavvezone.png" alt="WAVVEZONE"/>
        </h1>
        <div class="intro-sec01-content">
          <p class="intro-sec01-tit">{{ pooqzoneInfo.merchantMessage }}</p>
          <p class="intro-sec01-text">{{ pooqzoneInfo.productMessage1 }}</p>
          <p class="intro-sec01-text">{{ pooqzoneInfo.productMessage2 }}</p>
          <button @click.prevent="goFreeCategory()" class="intro-sec01-btn">{{ pooqzoneInfo.buttonMessage }}</button>
        </div>

        <div class="intro-sec01-id">
          이미 웨이브 아이디가 있으신가요?
          <a @click.prevent="exitPooqzone()" href="#" class="intro-sec01-link">기존 서비스로 보기</a>
        </div><!--intro-sec01-id//-->

        <!-- 핀코드 모달 -->
        <pooq-zone-pin-code v-if="showModal"/>
        <!-- 핀코드 모달 -->
      </div><!--intro-sec01-top//-->
      <div class="intro-sec01-bt" >
        <span class="btn-pz-txt">
            <span>대한민국 대표 앱, 웨이브<br />아직 이용해보지 않으셨나요?</span>
        </span>
        <button class="btn-pz-scroll" type="button" @click="pageChange('sec02')"></button>
      </div><!--intro-sec01-bt//-->
    </section>

    <section id="sec02" class="intro-sec02">
      <div class="intro-sec02-top">
        <p class="intro-sec02-tit">TV 그 이상, 대한민국 대표 앱<br />웨이브</p>
        <a @click.prevent="exitPooqzone()" href="#" class="intro-sec02-btn">웨이브 둘러보기</a>

        <div class="intro-slider-wrap">
          <!-- Slider main container -->
          <div id="swiper-container-pooqzonelist" class="swiper-container intro-slider swiper-container-horizontal">
            <swiper :options="swiperOptions">
              <swiper-slide v-for="(dataItem, index) in pooqzoneInfo.list" :key="'pooqzone_'+index">
                <img :src="getImage(dataItem.ImageUrl)" :alt="dataItem.Alt"/>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination" slot="pagination"></div>
          </div>
        </div><!--intro-slider-wrap//-->
      </div><!--intro-sec01-top//-->
    </section>
  </div>
</template>

<script>
// import { stringify } from 'query-string'
import PooqZonePinCode from '@/components/pooqzone/PooqZonePinCode'
import { EventBus } from '@/components/eventbus/EventBus'
import { CommonService } from '@/common/api/api.service'
import utils from '@/common/util/utils'
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS } from '@/common/devicetype.const'
import { resizeThumbnail } from '@/common/image.filter'

export default {
  name: 'PooqZone',
  components: {
    PooqZonePinCode
  },
  data () {
    return {
      pooqzoneInfo: null,
      showModal: false,
      device: utils.cookies.getDevice(), // 디바이스 타입
      // agencyname: this.$utils.queryString.getQueryParamValue('agencyname'), // 업체명
      producttype: utils.queryString.getQueryParamValue('producttype'), // 웨이브온 타입
      pincode: utils.queryString.getQueryParamValue('pincode'), // 핀코드 여부
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: false
        },
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 15
      }
    }
  },
  methods: {
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: '20', quality: 80 })
    },
    // 웨이브온 서비스로 보기 버튼 클릭
    goFreeCategory () {
      if (this.pincode === 'y') {
        this.showModal = true
      } else {
        this.enterPooqzone('')
      }
    },
    // 웨이브온 서비스로 진입
    enterPooqzone (pincode) {
      try {
        if (this.device === DEVICE_TYPE_IOS) {
          window.webkit.messageHandlers.enterPooqzone.postMessage(pincode || 'none')
        } else if (this.device === DEVICE_TYPE_ANDROID) {
          window.Android.enterPooqzone(pincode)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 기존 Pooq 서비스로 보기
    exitPooqzone () {
      try {
        if (this.device === DEVICE_TYPE_IOS) {
          window.webkit.messageHandlers.exitPooqzone.postMessage('none')
        } else if (this.device === DEVICE_TYPE_ANDROID) {
          window.Android.exitPooqzone()
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 페이지 변경
    pageChange (target) {
      const element = document.getElementById(target)
      scrollTo(0, element.getBoundingClientRect().top)
    }
  },
  created () {
    // 웨이브온 무료 카테고리 리스트 체크
    // if (this.producttype.indexOf('movie') > -1) {
    //   this.categoryTitle = '방송 LIVE, 방송 VOD, 영화';
    //   this.buttonText = '방송/영화 무료보기';
    // } else {
    //   this.categoryTitle = '방송 LIVE, 방송 VOD';
    //   this.buttonText = '방송 무료보기';
    // }

    // pooqzone api get
    // pooqzonetype 값을 다시한번 받아가지고 온다. (처음 index에는 none값으로 뿌려지니까)
    CommonService.pooqzoneCheck().then((response) => {
      // console.log('this.pooqzoneInfo.pooqzonetype', this.pooqzoneInfo.pooqzonetype);
      // this.data = response.data;
      // this.dataList = response.data.list;
      // console.log('>>>>>> response.data', response.data);
      this.pooqzoneInfo = response.data

      // pooqzonetype값에 맞쳐서 문구, 버튼 텍스트 변경
      // let superPack = this.pooqzoneInfo.producttype.indexOf('movie') > -1;
      // this.agencyname = this.pooqzoneInfo.agencyname +' 웨이브온입니다.';
      // switch(this.pooqzoneInfo.pooqzonetype) {
      //   case 'pcbang':
      //     this.categoryTitle = superPack ? '방송 LIVE, 방송 VOD, 영화, 만화' : '방송 LIVE, 방송 VOD, 만화';
      //     this.buttonText = superPack ? '방송/영화/만화 무료보기' : '방송/만화 무료보기';
      //     break;
      //   case 'library':
      //     this.agencyname = this.pooqzoneInfo.agencyname + ' 실시간 영상서비스입니다.';
      //     this.categoryTitle = superPack ? '영화, 다큐, 방송 콘텐츠' : '다큐, 방송 콘텐츠';
      //     this.buttonText = superPack ? '방송/영화 무료보기' : '방송 무료보기';
      //     break;
      //   case 'hospital':
      //   default:
      //     this.categoryTitle = superPack ? '방송 LIVE, 방송 VOD, 영화' : '방송 LIVE, 방송 VOD';
      //     this.buttonText = superPack ? '방송/영화 무료보기' : '방송 무료보기';
      //     break;
      // }
    })

    // 웨이브온 핀코드 닫기
    EventBus.$on('setPinCodePage', value => {
      this.showModal = value
    })

    EventBus.$on('clickPinCodeLogin', pincode => {
      this.enterPooqzone(pincode)
    })

    // 웨이브온 리스트
    this.swiperElement = '#swiper-container-pooqzonelist'
    this.isReady = true
  },
  filters: {
    imgUrl (value) {
      if (!value) return ''
      return `${location.protocol}//${value}`
    }
  }
  // created () {
  //   this.query = stringify(this.$route.params)
  // }

}
</script>

<style scoped>
  body {
    width: 100%;
    overflow-x: hidden;
    word-break: keep-all;
    word-wrap: break-word;
  }
  .intro-top-div {
    height: 100%;
  }
  .intro-sec01 {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
  }
  section {
    margin: 0 auto;
  }
  .intro-sec01-top {
    width: 100%;
    height: -webkit-calc(100% - 100px);
    height: -moz-calc(100% - 100px);
    height: calc(100% - 100px);
    min-height: 420px;
    text-align: center;
    position: relative;
    background: url(../../assets/images/intro/intro-sec01-bg.png) no-repeat;
    background-size: cover;
  }
  .intro-pooqzone {
    padding: 19px;
    font-size: 0;
    text-align: center;
  }
  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 400;
  }
  .intro-pooqzone>img {
    width: 100px;
  }
  img {
    outline: none;
  }
  button, img, input, select, textarea {
    vertical-align: middle;
  }
  abbr, acronym, fieldset, iframe, img, td, th {
    border: 0 none;
    padding: 0;
    margin: 0;
    outline: none;
  }
  .intro-sec01-content {
    position: absolute;
    width: 100%;
    top: 50%;
    margin-top: -105px;
  }
  .intro-sec01-text, .intro-sec01-tit {
    font-size: 24px;
    color: #fff;
    line-height: 36px;
    font-weight: 400;
  }
  .intro-sec01-tit {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    max-height: 114px;
  }

  /*@media all and (min-width:375px){*/
  /*  .intro-sec01-tit{*/
  /*    -webkit-line-clamp: 3;*/
  /*  }*/
  /*  .intro-sec01-text, .intro-sec01-tit {*/
  /*    -webkit-line-clamp: 3;*/
  /*    font-size: 24px;*/
  /*    line-height: 38px;*/
  /*  }*/
  /*}*/
  .intro-sec01-btn {
    display: inline-block;
    height: 34px;
    margin-top: 20px;
    padding: 0 25px;
    border: 1px #1351f9 solid;
    border-radius: 18px;
    background-color: #1351f9;
    font-size: 14px;
    line-height: 32px;
    color: #fff;
    text-align: center;
  }
  button {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 0;
    border: none;
    background: transparent;
  }
  button, img, input, select, textarea {
    vertical-align: middle;
  }
  .intro-sec01-id {
    position: absolute;
    bottom: 20px;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
    text-align: center;
  }
  .intro-sec01-link {
    text-decoration: underline!important;
    display: block;
    margin-top: 8px;
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }
  .intro-sec01-bt {
    position: absolute;
    bottom: 0;
    display: block;
    width: 100%;
    height: 100px;
    padding: 26px 0 26px 30px;
    background-color: #1351f9;
  }
  .btn-pz-txt {
    display: block;
    min-width: 228px;
    width: 80%;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
  }
  .pooqtv-logo01 {
    display: block;
    text-align: left;
    margin-bottom: 5px;
  }
  .pooqtv-logo01>img {
    width: 64px;
  }
  .btn-pz-scroll {
    position: absolute;
    top: 50%;
    right: 25px;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    background-image: url(../../assets/images/intro/intro-sec01-arrow.png);
    background-repeat: no-repeat;
    background-size: cover;
  }
  .intro-sec02 {
    width: 100vw;
    /*height: 100vh;*/
    min-height: 688px;
    position: relative;
    overflow: hidden;
  }
  .intro-sec02-top {
    width: 100%;
    text-align: center;
    height: calc(100% - 80px);
    padding: 40px 0;
  }
  .pooq-tv-logo02 {
    margin-bottom: 15px;
  }
  .pooq-tv-logo02>img {
    width: 64px;
  }
  .intro-sec02-btn, .intro-sec02-tit {
    color: #fff;
    font-weight: 400;
  }
  .intro-sec02-tit {
    font-size: 24px;
    line-height: 36px;
    color: #fff;
    font-weight: 400;
  }
  a, a:active, a:hover, a:link, a:visited {
    text-decoration: none;
  }
  .intro-sec02-btn {
    display: inline-block;
    height: 34px;
    margin: 20px 0 40px;
    padding: 0 25px;
    border: 1px #1351f9 solid;
    border-radius: 18px;
    background-color: #1351f9;
    font-size: 14px;
    line-height: 32px;
    color: #fff;
    text-align: center;
  }
  .swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    z-index: 1;
  }
  .intro-slider {
    padding-bottom: 30px;
  }
  .intro-sec02-bt {
    width: 100%;
    height: 60px;
    background: url(../../assets/images/intro/intro-sec02-bt-bg.png) no-repeat;
    background-size: 100% 100%;
  }
  .intro-sec02-bt>img {
    width: 132px;
  }
  .intro-slider .swiper-slide {
    width: 220px!important;
    border: 1px #2f2f2f solid;
  }
  .intro-slider .swiper-slide img{
    width: 100%;
  }
  .swiper-pagination {
    width: 100%;
  }
  .intro-top-div .intro-slider .swiper-pagination-bullets {
    bottom: 0!important;
    font-size: 0;
  }
  .swiper-pagination-bullets .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: .2;
    margin: 0 3px !important;
  }
</style>
